<template>
	<div id="app">
		<!-- 条件渲染：如果不是登录页面，显示头部和底部 -->
		<template v-if="$route.path !== '/login'">
			<header class="app-header">
				<div class="header-left">
					<div class="logo">
						<img src="/icon/common/logo.png" alt="Sourcefind" class="logo-img">
					</div>
					<!-- 选择语言 -->
					<el-dropdown>
						<span class="dropdown-trigger">
							{{ language[$i18n.locale]}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="changeLanguage(item.value)" v-for="item in languagelist"
								:key="item.value">
								{{item.label}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<!-- 选择币种 -->
					<el-dropdown>
						<span class="dropdown-trigger">{{ currencyEntity[selectCurrency]}} <i
								class="el-icon-arrow-down el-icon--right"></i></span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="changeCurrency(item)" v-for="item in currencies"
								:key="item.currency">
								{{item.currencySymbol}}({{item.currency}})
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<!-- 导航菜单 -->
					<nav class="nav-menu">
						<el-menu mode="horizontal" :default-active="activeMenu" background-color="transparent"
							text-color="#fff" active-text-color="#fff">
							<el-menu-item index="home" @click="onRouter('/home')">{{ $t('home') }}</el-menu-item>
							<el-menu-item index="merchants" @click="onRouter('/merchant')">
								{{ $t('merchants') }}</el-menu-item>
							<!-- <el-menu-item index="join" @click="onRouter('/join-us')">{{ $t('join') }}</el-menu-item> -->
						</el-menu>
					</nav>
				</div>

				<div class="header-right">
					<!-- 购物车 -->
					<div class="cart-container">
						<div class="cart">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<span class="cart-icon">
									<i class="el-icon-shopping-cart-2"></i>
									<!-- <span class="cart-count">26</span> -->
								</span>
								<span style="color: #fff;font-weight: bold;font-size: 16px;">{{ $t('cart') }}</span>
							</div>
						</div>
						<div class="cart-preview">
							<div v-if="isLogin">
								<div class="cart-preview-header">
									<span class="cart-preview-count">{{ $t('newlyAdded') }}</span>
								</div>
								<div class="cart-preview-content">
									<div v-if="cartItems.length === 0" class="cart-empty">
										<img src="/icon/common/nodata.png" style="height: 110px;margin-bottom: 10px;">
										<p>{{ $t('cartEmpty') }}</p>
									</div>
									<div v-else class="cart-items">
										<div v-for="item in cartItems" :key="item.id" class="cart-item">
											<div style="width: 340px;display: flex;align-items: center;">
												<img :src="item.image" :alt="item.name" class="cart-item-image">
												<div class="cart-item-info">
													<span class="cart-item-name">{{ item.name }}</span>
													<span class="cart-item-remark">{{ item.remark }}</span>
												</div>
											</div>
											<div
												style="width: 130px;display: flex;align-items: center;justify-content: space-around;">
												<div class="cart-item-price">{{ item.price }} </div>
												<div class="cart-item-delete">{{ $t('delete') }}</div>
											</div>
										</div>
									</div>
								</div>
								<div class="cart-preview-footer" v-if="cartItems.length > 0">
									<div>
										<span>{{ $t('totalSKU') }}</span>
										<span style="color: #D9001B;font-weight: bold;">24</span>
										<span>{{ $t('unit') }}</span>
										<span>(</span>
										<span style="color: #D9001B;font-weight: bold;">124</span>
										<span>{{ $t('unitPiece') }}</span>
										<span>)</span>
										<span>{{ $t('items') }}</span>
									</div>
									<el-button type="danger" plain size="small" @click="$router.push('/cart')"
										class="view-cart-btn">{{ $t('viewAll') }}</el-button>
								</div>
							</div>

							<div v-if="!isLogin" class="user-preview-content">
								<div class="user-not-login" style="height: 400px;">
									<span style="margin-bottom: 15px;">{{ $t('loginToViewCart') }}</span>
									<el-button type="danger" plain @click="login" size="small" class="login-btn">
										{{ $t('login') }}</el-button>
								</div>
							</div>
						</div>
					</div>

					<!-- 用户信息 -->
					<div class="user-info">
						<div class="user-profile">
							<img :src="isLogin?`${user.face}`:'/icon/user/default.png'" alt="User Avatar"
								class="user-avatar">
						</div>
						<div class="user-preview">
							<div v-if="isLogin">
								<div class="user-preview-content">
									<div class="user-menu-item" @click="toFollow('followedMerchants')">
										<i class="el-icon-s-check"></i>
										<span>{{ $t('followedMerchants') }}</span>
									</div>
									<div class="user-menu-item" @click="toFollow('productFavorites')">
										<i class="el-icon-star-on"></i>
										<span>{{ $t('productFavorites') }}</span>
									</div>
									<div class="user-menu-item" @click="toFollow('browsingHistory')">
										<i class="el-icon-time"></i>
										<span>{{ $t('browsingHistory') }}</span>
									</div>
									<div class="user-menu-item" @click="toFollow('complaintsFeedback')">
										<i class="el-icon-warning"></i>
										<span>{{ $t('complaintsFeedback') }}</span>
									</div>
									<div class="user-menu-item" @click="toFollow('inquiryRecords')">
										<i class="el-icon-message"></i>
										<span>{{ $t('inquiryRecords') }}</span>
									</div>
									<div class="user-menu-item" @click="showPerson">
										<i class="el-icon-user"></i>
										<span>{{ $t('personalInfo') }}</span>
									</div>
									<div class="user-menu-item" @click="toPurchasinng">
										<i class="el-icon-s-operation"></i>
										<span>{{ $t('purchasingPlatformAccount') }}</span>
									</div>
								</div>
								<div class="user-preview-footer">
									<el-button type="danger" plain @click="logout">
										<i class="el-icon-switch-button"></i>
										{{ $t('logout') }}</el-button>
								</div>
							</div>
							<div v-if="!isLogin" class="user-preview-content">
								<div class="user-not-login">
									<span style="margin-bottom: 15px;">{{ $t('loginToViewProfile') }}</span>
									<el-button type="danger" plain @click="login" size="small" class="login-btn">
										{{ $t('login') }}</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</template>

		<!-- 主内容区 -->
		<main :class="['app-main', { 'login-main': $route.path === '/login' }]">
			<router-view />
		</main>

		<!-- 条件渲染：如果不是登录页面，显示底部 -->
		<footer v-if="$route.path !== '/login'" class="footer">
			<div class="footer-content">
				<div class="footer-section">
					<img src="/icon/common/logo-bottom.png" alt="">
				</div>
				<div class="footer-section" style="padding-left: 20px;">
					<h4>{{ $t('companyInfo') }}</h4>
					<ul>
						<li><a href="#">{{ $t('aboutSourcefind') }}</a></li>
						<li><a href="#">{{ $t('becomeMerchant') }}</a></li>
						<li><a href="#">{{ $t('feedbackSuggestions') }}</a></li>
						<li><a href="#">{{ $t('contactSupport') }}</a></li>
					</ul>
				</div>
				<div class="footer-section" style="padding-left: 20px;">
					<h4>{{ $t('legalTerms') }}</h4>
					<ul>
						<li><a href="#">{{ $t('privacyPolicy') }}</a></li>
						<li><a href="#">{{ $t('termsOfService') }}</a></li>
						<li><a href="#">{{ $t('cookieStatement') }}</a></li>
					</ul>
				</div>
				<div class="footer-section">
					<div class="qr-section">
						<img src="/icon/common/qrcode.svg" alt="QR Code" class="qr-image">
						<span class="qr-text">{{ $t('scanToDownload') }}</span>
					</div>
					<div class="app-buttons">
						<button class="app-button app-store">
							<img src="/icon/common/download-ios.svg">
							<span class="app-text">
								<span class="download-text">{{ $t('downloadAppleStore') }}</span>
							</span>
						</button>
						<button class="app-button google-play">
							<img src="/icon/common/download-android.svg">
							<span class="app-text">
								<span class="download-text">{{ $t('downloadGooglePlay') }}</span>
							</span>
						</button>
					</div>
				</div>
			</div>
			<div class="footer-bottom">
				<p>&copy; 2026 {{ $t('copyright') }}</p>
			</div>
		</footer>
		<!-- 个人信息组件 -->
		<EditPersonDialog :visible.sync="showPersonDialog" @save-callback="checkLoginStatus"/>
	</div>
</template>

<script>
	import EditPersonDialog from './components/EditPersonDialog.vue'
	import storage from "@/utils/storage.js";
	import userApi from './api/user'
	import homeApi from './api/home'
	export default {
		name: 'App',
		components: {
			EditPersonDialog
		},
		data() {
			return {
				isLogin: false,
				languagelist: [], //语言包
				language: {},
				selectCurrency: '', //选中的币种
				currencyEntity: {},
				currencies: [], //币种				
				user: {
					name: '',
					avatar: '/img/CNfans_logo.jpeg'
				},
				showCartPreview: false,
				cartItems: [],
				activeMenu: 'home',
				showPersonDialog: false
			}
		},
		created() {
			this.checkLoginStatus()
			// 监听路由变化，在每次路由切换时检查登录状态
			this.$router.beforeEach((to, from, next) => {
				this.checkLoginStatus()
				next()
			})
			this.selectCurrency = storage.getCurrency();
			this.getLanguage();
			this.getCurreny();
			if (this.$route.path == '/join-us') {
				this.activeMenu = 'join';
			} else if (this.$route.path == '/merchant') {
				this.activeMenu = 'merchants';
			}
		},
		watch: {
			$route(to) {
				if (to.path === '/home') {
					this.activeMenu = 'home'
				} else {
					this.activeMenu = to.path.slice(1)
				}
			},
			// 监听登录状态变化
			isLogin: {
				handler(newVal) {
					// 当登录状态发生变化时，可以在这里执行相应的操作
					console.log('登录状态变化:', newVal)
				},
				immediate: true
			}
		},
		methods: {
			showPerson() {
				this.showPersonDialog = true;
			},
			//页面跳转，当路由一样时，不跳转
			onRouter(path) {
				if (this.$route.path == path) {
					return;
				}
				this.$router.push({
					path
				})
			},
			//获取币种
			async getCurreny() {
				const res = await homeApi.getCurreny();
				this.currencies = res.result;
				this.currencies.map(item => {
					this.currencyEntity[item.currency] = `${item.currencySymbol}(${item.currency})`;
				})
			},
			//获取语言包
			async getLanguage() {
				const res = await userApi.getLanguage();
				this.languagelist = res.result.map(item => ({
					value: item.langCode,
					label: item.displayName
				}));
				this.languagelist.map(item => {
					this.language[item.value] = item.label;
				})
			},
			//改变选中的语言
			changeLanguage(lang) {
				this.$i18n.locale = lang
				storage.setLanguage(lang);
			},
			changeCurrency(element) {
				this.selectCurrency = element.currency;
				storage.setCurrency(element.currency);
				storage.setCurrencySymbol(element.currencySymbol);
				window.location.reload();
			},
			checkLoginStatus() {
				// 与Login.vue中的存储逻辑保持一致
				const userInfo = storage.getUserInfo();
				const token = storage.getToken();
				const refreshToken = storage.getRefreshToken();
				if (userInfo && token) {
					this.isLogin = true
					this.user = JSON.parse(userInfo)
				} else {
					this.isLogin = false
				}
				const lang = storage.getLanguage()
				if (lang) {
					this.$i18n.locale = lang
				} else {
					// 确保默认语言为英文
					this.$i18n.locale = 'en'
					storage.setLanguage('en');
				}
				const currency = storage.getCurrency();
				if (currency) {
					this.currency = currency
				}
			},
			toFollow(type) {
				// 获取当前路由信息
				const currentPath = this.$route.path
				const currentType = this.$route.query.type
				// 检查是否在follow页面且type参数发生变化
				if (currentPath === '/follow') {
					// 无论type参数是否相同，都添加时间戳参数来确保页面重新加载
					this.$router.replace({
						path: '/follow',
						query: {
							type: type,
							timestamp: new Date().getTime() // 添加时间戳参数
						}
					})
				} else {
					// 正常跳转
					this.$router.push({
						path: '/follow',
						query: {
							type: type
						}
					})
				}
			},
			toPurchasinng() {
				this.$router.push('/purchasing')
			},
			login() {
				this.$router.push('/login')
			},
			//退出登录
			logout() {
				this.$confirm(this.$t('confirmLogout'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning',
					showClose: false
				}).then(() => {
					this.confirmLogout();
				}).catch(() => {});
			},
			async confirmLogout() {
				const res = await userApi.logout();
				storage.removeToken();
				storage.removeUser();
				storage.removeRefreshToken();
				this.isLogin = false
				this.user = {
					name: '',
					avatar: ''
				}
				window.location.reload();
			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		font-family: Arial, sans-serif;
	}

	.app-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 40px 0 200px;
		height: 80px;
		background-color: #016AF8;
		color: #fff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	/* Responsive adjustments */
	@media (max-width: 1200px) {
		.app-header {
			padding: 0 15px 0 100px;
		}

		.header-left {
			gap: 30px;
		}
	}

	@media (max-width: 992px) {
		.header-left {
			gap: 20px;
		}

		.logo-img {
			width: 150px;
		}

		.el-menu-item {
			font-size: 14px !important;
			padding: 0 15px !important;
			width: 120px !important;
		}
	}

	@media (max-width: 768px) {
		.app-header {
			height: 70px;
			flex-wrap: wrap;
		}

		.header-left {
			gap: 15px;
			width: 100%;
			justify-content: space-between;
		}

		.nav-menu {
			display: none;
		}

		.logo-img {
			width: 120px;
		}

		.dropdown-trigger {
			font-size: 13px;
		}

		.header-right {
			gap: 10px;
			margin-top: 10px;
			width: 100%;
			justify-content: flex-end;
		}

		.cart-icon {
			font-size: 22px;
		}

		.user-avatar {
			width: 35px;
			height: 35px;
		}
	}

	@media (max-width: 480px) {
		.header-left {
			gap: 10px;
		}

		.logo-img {
			width: 100px;
		}

		.header-right {
			gap: 5px;
		}

		.cart-count {
			font-size: 10px;
			padding: 1px 4px;
			min-width: 16px;
		}
	}

	.header-left {
		display: flex;
		align-items: center;
		gap: 50px;
	}

	.login-btn {
		font-size: 14px !important;
	}

	.logo {
		display: flex;
		align-items: center;
		gap: 10px;
		font-size: 24px;
		font-weight: bold;
		color: #fff;
	}

	.logo-img {
		width: 200px;
	}

	.logo-text {
		color: #fff;
	}

	.nav-menu {
		flex: 1;
	}

	/* Hide the default menu border */
	.el-menu.el-menu--horizontal {
		border-bottom: none !important;
	}

	.el-menu-item {
		color: #fff !important;
		font-size: 17px !important;
		font-weight: bold !important;
		padding: 0 20px !important;
		height: 80px !important;
		line-height: 80px !important;
		width: 150px !important;
		text-align: center;
		border-bottom: 0 !important;
	}

	.el-menu-item:hover {
		background-color: rgba(255, 255, 255, 0.2) !important;
	}

	.el-menu-item.is-active {
		background-color: #0160E0 !important;
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 15px;
		justify-content: center;
		width: 200px;
	}

	.dropdown-trigger {
		cursor: pointer;
		color: #F59A23;
		display: flex;
		align-items: center;
		font-size: 15px;
		font-weight: bold;
	}

	.separator {
		color: rgba(255, 255, 255, 0.5);
	}

	.cart {
		position: relative;
		cursor: pointer;
		padding: 10px;
		border-radius: 4px;
		transition: background-color 0.3s ease;
	}

	.cart-container:hover .cart {
		background-color: #0171F9;
	}

	.cart-container:hover .cart .cart-icon,
	.cart-container:hover .cart .cart-icon i {
		color: #fff;
	}

	.cart-container:hover .cart span:not(.cart-count) {
		color: #fff !important;
	}

	.cart-container {
		position: relative;
		display: flex;
		align-items: center;
	}

	.cart-preview {
		position: absolute;
		top: 74px;
		right: 0;
		width: 500px;
		height: 400px;
		background: #fff;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
		z-index: 10000;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.3s ease, visibility 0.3s ease;
	}

	.cart-container:hover .cart-preview {
		opacity: 1;
		visibility: visible;
	}

	.cart-preview-header {
		padding: 10px 20px;
		border-bottom: 1px solid #eee;
		font-weight: 600;
		font-size: 16px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.cart-preview-count {
		color: #000;
		font-weight: normal;
		font-size: 14px;
	}

	.cart-preview-content {
		flex: 1;
		overflow-y: auto;
		padding: 15px;
		width: 500px;
	}

	.cart-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		color: #999;
		padding-top: 60px;
	}

	.cart-empty p {
		font-size: 15px;
	}

	.cart-items {
		display: flex;
		flex-direction: column;
		gap: 15px;
		padding: 0;
		border-radius: 10px;
		width: 470px;
	}

	.cart-item {
		display: flex;
		gap: 15px;
		border-radius: 6px;
		background: #f2f2f2;
	}

	.cart-item:hover {
		border-color: transparent;
	}

	.cart-item-image {
		width: 60px;
		height: 60px;
		border-radius: 10px;
		object-fit: cover;
	}

	.cart-item-info {
		display: flex;
		flex-direction: column;
		width: 80%;
		padding-left: 10px;
	}

	.cart-item-name {
		font-size: 15px;
		font-weight: 500;
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.cart-item-remark {
		padding-top: 5px;
		font-size: 12px;
		color: #999;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.cart-item-price {
		font-size: 14px;
		font-weight: 600;
		color: #F59A23;
	}

	.cart-item-delete {
		font-size: 14px;
		font-weight: 600;
		color: #D9001B;
		display: flex;
		align-items: center;
		text-align: center;
	}

	.cart-preview-footer {
		padding: 10px;
		border-top: 1px solid #eee;
		background: #f9f9f9;
		color: #000;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: absolute;
		width: 100%;
		bottom: 0;
	}

	.view-cart-btn {
		background-color: #0171F9;
		border-color: #0171F9;
	}

	.view-cart-btn:hover {
		background-color: #0158d4;
		border-color: #0158d4;
	}

	.cart-icon {
		cursor: pointer;
		font-size: 26px;
		color: #fff;
	}

	.cart-count {
		position: absolute;
		right: -3px;
		background-color: #D9001B;
		color: #fff;
		font-size: 12px;
		padding: 2px 6px;
		border-radius: 10px;
		min-width: 20px;
		text-align: center;
		top: 5px;
	}

	.user-info {
		position: relative;
		margin-left: 8px;
	}

	.user-profile {
		cursor: pointer;
		padding: 10px;
		border-radius: 50%;
		transition: background-color 0.3s ease;
	}

	.user-avatar {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		border: 2px solid rgba(255, 255, 255, 0.5);
	}

	/* User Preview Styles */
	.user-preview {
		position: absolute;
		top: 74px;
		right: -20px;
		width: 200px;
		background: #fff;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
		z-index: 10000;
		overflow: hidden;
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.3s ease, visibility 0.3s ease;
	}

	.user-info:hover .user-profile {
		background-color: #0171F9;
	}

	.user-info:hover .user-preview {
		opacity: 1;
		visibility: visible;
	}

	.user-preview-content {}

	.user-not-login {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 12px 20px;
		height: 200px;
		transition: background-color 0.3s ease;
		color: #333;
		font-size: 14px;
	}

	.user-menu-item {
		display: flex;
		align-items: center;
		gap: 15px;
		padding: 12px 20px;
		cursor: pointer;
		transition: background-color 0.3s ease;
		color: #333;
		font-size: 15px;
	}

	.user-menu-item:hover {
		background-color: #f5f7fa;
		color: #0171F9;
	}

	.user-menu-item i {
		font-size: 18px;
		width: 20px;
		text-align: center;
	}

	.user-preview-footer {
		padding: 15px 20px;
		border-top: 1px solid #eee;
		background-color: #fafafa;
		display: flex;
		justify-content: center;
	}

	/* Custom button style */
	.el-button--plain {
		border-color: #fff;
		color: #fff;
	}

	.el-button--plain:hover {
		background-color: rgba(255, 255, 255, 0.2);
		border-color: #fff;
		color: #fff;
	}

	.app-main {
		min-height: calc(100vh - 80px);
	}

	/* 登录页面的主内容区样式 */
	.login-main {
		min-height: 100vh;
		padding: 0;
	}

	/* Footer */
	.footer {
		background-color: #00245B;
		color: #fff;
		padding: 50px 0 20px;
	}

	.footer-content {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 40px;
		padding: 0 200px;
	}

	.footer-section {
		flex: 1;
	}

	.footer-section:last-child {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		gap: 30px;
	}

	.qr-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	}

	.qr-image {
		width: 140px !important;
		height: 140px !important;
		object-fit: contain;
	}

	.qr-text {
		font-size: 14px;
		color: #a0aec0;
		text-align: center;
	}

	.footer-section h4 {
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 20px;
		color: #fff;
	}

	.footer-section ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.footer-section ul li {
		margin-bottom: 12px;
	}

	.footer-section ul li a {
		color: #a0aec0;
		text-decoration: none;
		font-size: 14px;
		transition: color 0.3s ease;
	}

	.footer-section ul li a:hover {
		color: #fff;
	}

	.footer-section img {
		width: 280px;
	}

	.app-buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 300px;
	}

	.app-button {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 13px 20px;
		border: none;
		border-radius: 6px;
		cursor: pointer;
		transition: all 0.3s ease;
		text-align: left;
	}

	.app-button img {
		width: 25px;
	}

	.app-button.app-store {
		background-color: rgba(0, 0, 0, 0.35);
		color: #fff;
		border-radius: 50px;
	}

	.app-button.app-store:hover {
		background-color: #0171F9;
	}

	.app-button.google-play {
		background-color: rgba(0, 0, 0, 0.35);
		color: #fff;
		border-radius: 50px;
	}

	.app-button.google-play:hover {
		background-color: #0171F9;
	}

	.app-icon {
		font-size: 24px;
	}

	.app-text {
		display: flex;
		flex-direction: column;
	}

	.download-text {
		font-size: 16px;
		font-weight: 600;
	}

	.footer-bottom {
		margin-top: 40px;
		padding-top: 20px;
		border-top: 1px solid #2d3748;
		text-align: center;
	}

	.footer-bottom p {
		font-size: 16px;
		color: #fff;
		margin: 0;
	}

	.vip-tag-left {
		display: flex;
		background-color: #FEF5E9;
		padding: 5px 6px;
		border-radius: 4px;
		margin-right: 5px;
		align-items: center;
		gap: 5px;
		color: #F59A23;
		font-size: 12px;
		font-weight: bold;
	}

	.section-header {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 20px;
	}

	.section-divider {
		width: 5px;
		height: 20px;
		background-color: #016AF8;
		border-radius: 2px;
	}

	.nodata {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 1200px;
		padding: 20px;
	}

	.nodata img {
		width: 180px;
		height: 180px;
	}

	.nodata span {
		padding-top: 20px;
		color: #999;
		font-size: 16px;
	}

	.show-mask {
		position: relative;
		z-index: 100;
	}

	/* 加载中动画效果 */
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 10px;
	}

	.loading-more .el-icon-loading {
		font-size: 24px;
		color: #666;
		animation: rotating 2s linear infinite;
	}

	.loading-more span {
		margin-left: 10px;
		color: #999;
		font-size: 16px;
	}

	/* 已全部加载样式 */
	.load-all {
		font-size: 16px;
		padding: 10px 0;
	}
</style>